<div style='padding-left:40px;'>
  <p>
    <button kendoButton routerLink="/welcome" [icon]="'arrow-left'" look="outline" >Back</button>
  </p>

  <div>Hi you are here because you have a coupon code!  We occassionally participate in celebration events and conferences - make sure you give the
    speaker good reviews and feedback!
  </div>

  <input kendoTextBox type="text" [(ngModel)]="tryCoupon">

  <button kendoButton [icon]="'check'" look="outline" (click)="verify()">Verify</button>


  @if (this.coupon) {
    <app-subscription-payment [promotion]="true" [coupon]="coupon" [couponText]="couponText" [discount]="discount"></app-subscription-payment>
  }
</div>
